import React, { useState } from 'react'
import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import { Link } from 'react-router-dom'

export default function DataReportTable({ reportData, setReportData }) {
  const [sortedKey, setSortedKey] = useState('')
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc',
  })

  const sortTable = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    const sorted = [...reportData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })
    setReportData(sorted)
    setSortedKey(key)
    setSortConfig({ key, direction })
  }

  // Function to calculate the difference in days between two dates
  const calculateDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate)
    const end = new Date(endDate)
    const totalDays = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1
    return totalDays
  }
  const DESIGNATION_TYPE_NAMES = {
    1: 'Staff',
    2: 'Worker',
    3: 'Daily Wager'
  };
  return (
    <>
      <thead class="thead-dark" style={{ backgroundColor: '#e8e9eb' }}>
        <tr>
          <th onClick={() => sortTable('id')}>Sr</th>
          <th onClick={() => sortTable('id')}>
            Employee ID{' '}
            {sortedKey === 'id' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('full_name')}>
            Full Name
            {sortedKey === 'full_name' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>

          <th onClick={() => sortTable('designations')}>
            Designation
            {sortedKey === 'designations' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('designations')}>
            Type
            {sortedKey === 'designations' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('department')}>
            Department
            {sortedKey === 'department' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('start_date')}>
            start Date
            {sortedKey === 'start_date' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('end_date')}>
            End Date
            {sortedKey === 'end_date' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('total_days')}>
            Total Days
            {sortedKey === 'total_days' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('paid_type')}>
            Paid Type
            {sortedKey === 'paid_type' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('leave_type')}>
            Leave Type
            {sortedKey === 'leave_type' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('day_type')}>
            Day Type
            {sortedKey === 'day_type' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th style={{ width: '100px' }} onClick={() => sortTable('remarks')}>
            Remarks
            {sortedKey === 'remarks' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('created_by')}>
            Applied By
            {sortedKey === 'created_by' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
        </tr>
      </thead>
      <tbody>
        {reportData.map((item, index) => (
          <tr key={item.id}>
            <td>{index + 1}</td>
            <td style={{ color: 'black' }}>
              <Link to={`/employee-profile?id=${item.id}&tab=emp_leave`} target="_blank">
                {item.employee_id}
              </Link>
            </td>
            <td style={{ color: 'blue' }}>
              <Link to={`/employee-profile?id=${item.employee_id}&tab=emp_leave`} target="_blank">
                {item.employee.full_name}
              </Link>
            </td>
            <td>{item.employee.designation.name}</td>
            <td>
              {item.employee.designation.is_officer === 1
                ? 'Officer'
                : DESIGNATION_TYPE_NAMES[item.employee.designation.type]
              }
            </td>
            <td>{item.employee.department.name}</td>
            <td>{item.start_date}</td>
            <td>{item.end_date}</td>
            <td>{calculateDaysDifference(item.start_date, item.end_date)} Days</td>
            <td style={{ color: 'green' }}>{item.paid_type}</td>
            <td>{item.leave_type.name}</td>
            <td>{item.day_type}</td>
            <td>{item.remarks}</td>
            <td>{item.created_by.name}</td>
          </tr>
        ))}
      </tbody>
    </>
  )
}
